import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import Home from "./components/Home";
import AuthRequest from "./pages/AuthRequest";
import AuthVerify from "./pages/AuthVerify";
import Setup from "./pages/Setup";
import SetupIsd from "./pages/SetupIsd";
import Season from "./pages/Season";
import LineupEditor from "./pages/LineupEditor";
import ScoreEditor from "./pages/ScoreEditor";

// Top-level router. Chunk 4/6 adds /auth/request, /auth/verify, /setup.
// Chunk 5/6 adds /setup/isd. Chunk 6/6 adds /season + /season/:team_id.
// Lineup-editor chunk 1/2 adds /lineup/:matchId (the bot links here for
// lineup approval — see src/bot/dispatcher.ts). Score-editor chunk 2/2
// adds /score/:matchId (the bot links here to confirm+submit a score
// when it can't parse the texted score — same src/bot/dispatcher.ts).
export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/auth/request" element={<AuthRequest />} />
        <Route path="/auth/verify" element={<AuthVerify />} />
        <Route
          path="/setup"
          element={
            <RequireAuth>
              <Setup />
            </RequireAuth>
          }
        />
        <Route
          path="/setup/isd"
          element={
            <RequireAuth>
              <SetupIsd />
            </RequireAuth>
          }
        />
        <Route
          path="/season"
          element={
            <RequireAuth>
              <Season />
            </RequireAuth>
          }
        />
        <Route
          path="/season/:team_id"
          element={
            <RequireAuth>
              <Season />
            </RequireAuth>
          }
        />
        <Route
          path="/lineup/:matchId"
          element={
            <RequireAuth>
              <LineupEditor />
            </RequireAuth>
          }
        />
        <Route
          path="/score/:matchId"
          element={
            <RequireAuth>
              <ScoreEditor />
            </RequireAuth>
          }
        />
      </Route>
    </Routes>
  );
}
